export default "__VITE_ASSET__DMScsLea__"